import type { Run } from "./model/run";
import { SAVE_KEY, serializeRun, deserializeRun } from "./model/save";

// Private browsing and a full storage quota should never interrupt a game.
export function saveRun(run: Run): void { try { localStorage.setItem(SAVE_KEY, serializeRun(run)); } catch { /* playable in memory */ } }
export function loadRun(): Run | null { try { return deserializeRun(localStorage.getItem(SAVE_KEY)); } catch { return null; } }
export function clearRun(): void { try { localStorage.removeItem(SAVE_KEY); } catch { /* playable in memory */ } }
